import { render, staticRenderFns } from "./StandardContainer.vue?vue&type=template&id=6f9c64ce"
import script from "./StandardContainer.vue?vue&type=script&lang=js"
export * from "./StandardContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports